import { Component, OnInit } from '@angular/core';
import { HostData } from '../../classes/host-data.class';
import { HttpService } from '../../services/http.service';
import { MdDialog } from '@angular/material';
import { DialogShowInfoComponent } from './dialog-show-info.component';

@Component({
  selector: 'app-dialog-add-host',
  templateUrl: '../../templates/dialogs/dialog-add-host.component.html'
})

export class DialogAddHostComponent implements OnInit {

  HostData = new HostData();
  
  constructor(private httpService: HttpService,public dialog: MdDialog) {
  }

  ngOnInit() {}

  addHost() {
    this.httpService.addHost(this.HostData).subscribe(
      //3 callbacks (data,err,done)
      (_data: any) => {
        this.dialog.open(DialogShowInfoComponent, {
              data: _data
            });
      }, (_err: any) => {
        this.dialog.open(DialogShowInfoComponent, {
              data: _err
            });
      });
  }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dialogs/dialog-add-host.component.ts